import { apiCall } from "./service";
import {
  URL_CREATE_ATTACHMENT,
  URL_UPDATE_ATTACHMENT,
  URL_DELETE_ATTACHMENT,
} from "./URL";

// AttachementRefType enum values
export const AttachementRefType = {
  Client: 0,
  Portfolio: 1,
  Program: 2,
  Project: 3,
  Scope: 4,
  Task: 5,
  ChangeRequest: 6,
  Risk: 7,
  PurchaseOrder: 8,
  Invoice: 9,
  Communication: 10,
  Decision: 11,
  Appendix: 12,
  MakeSure: 13,
  Milestone: 14,
  Runbook: 15,
  RunbookAction: 16,
  ReshuffleRequest: 17,
};

export const api = {
  // Create attachment - POST /Attachments
  createAttachment(params) {
    const { title, notes, refId, refType, file } = params;
    
    const formData = new FormData();
    formData.append('Title', title);
    formData.append('Notes', notes || '');
    formData.append('RefId', refId);
    formData.append('RefType', refType);
    formData.append('File', file);

    return apiCall.filePost({
      url: URL_CREATE_ATTACHMENT,
      params: formData,
    });
  },

  // Update attachment - PUT /Attachments/{id}
  updateAttachment(id, params) {
    const { title, notes } = params;
    
    return apiCall.put({
      url: URL_UPDATE_ATTACHMENT(id),
      params: {
        title,
        notes: notes || '',
      },
    });
  },

  // Delete attachment - DELETE /Attachments/{id}
  deleteAttachment(id, hardDelete = false) {
    const url = hardDelete 
      ? `${URL_DELETE_ATTACHMENT(id)}?hardDelete=true`
      : URL_DELETE_ATTACHMENT(id);
    
    return apiCall.delete({url});
  },
}; 